/*
  LT Article – Editorial
  Behaviour for templates/article.editorial.json and its shortcode modules:
  - Copy-link share button
  - Featured Products carousel (arrows, disabled states)
  - AJAX "Add to Bag" that opens Rebuy Smart Cart (falls back to the native /cart/add POST)
  Standalone on purpose: application.js throws on article pages, so nothing here depends on it.
*/
(function () {
  if (window.__ltArticle) return;
  window.__ltArticle = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Copy link ---------- */

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      document.body.removeChild(field);
      if (copied) resolve();
      else reject();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lt-article-copy]');
    if (!button) return;
    event.preventDefault();

    var url = button.getAttribute('data-lt-article-copy');
    var label = button.querySelector('[data-lt-article-copy-label]');
    var status = button.parentNode.querySelector('[data-lt-article-copy-status]');
    var copiedLabel = button.getAttribute('data-copied-label') || 'Link copied';
    var copyLabel = button.getAttribute('data-copy-label') || 'Copy link';

    copyText(url).then(
      function () {
        button.classList.add('is-copied');
        if (label) label.textContent = copiedLabel;
        if (status) status.textContent = copiedLabel;
        clearTimeout(button._ltArticleTimer);
        button._ltArticleTimer = setTimeout(function () {
          button.classList.remove('is-copied');
          if (label) label.textContent = copyLabel;
          if (status) status.textContent = '';
        }, 3000);
      },
      function () {
        window.prompt(copyLabel, url);
      }
    );
  });

  /* ---------- Featured products carousel ---------- */

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupCarousel(section) {
    var track = section.querySelector('[data-lt-article-track]');
    var prev = section.querySelector('[data-lt-article-prev]');
    var next = section.querySelector('[data-lt-article-next]');
    if (!track || !prev || !next) return;

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth;
      section.classList.toggle('is-static', max <= 4);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }

    function step() {
      var card = track.querySelector('.lt-article-products__item');
      if (!card) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function move(direction) {
      track.scrollBy({ left: direction * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      move(-1);
    });
    next.addEventListener('click', function () {
      move(1);
    });
    track.addEventListener('scroll', updateArrows, { passive: true });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(updateArrows);
      observer.observe(section);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    updateArrows();
    window.addEventListener('load', updateArrows);
  }

  function setupCarousels() {
    document.querySelectorAll('[data-lt-article-carousel]').forEach(function (section) {
      if (section._ltArticleReady) return;
      section._ltArticleReady = true;
      setupCarousel(section);
    });
  }

  document.addEventListener('shopify:section:load', setupCarousels);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCarousels);
  else setupCarousels();

  /* ---------- Add to Bag ---------- */

  function refreshCart() {
    window.dispatchEvent(new CustomEvent('rebuy:cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') {
      window.Rebuy.Cart.fetchCart();
    }

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-quantity').forEach(function (element) {
          element.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function openCart() {
    var rebuy = window.Rebuy;
    if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
      rebuy.SmartCart.show();
    } else if (rebuy && rebuy.Cart && typeof rebuy.Cart.show === 'function') {
      rebuy.Cart.show();
    } else {
      window.location.href = root + 'cart';
    }
  }

  function addToBag(form) {
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-lt-article-atc-label]');
    var status = form.querySelector('[data-lt-article-atc-status]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    var originalLabel = label ? label.textContent : '';
    var data = new FormData(form);

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (label) label.textContent = button.getAttribute('data-adding-label') || 'Adding…';
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error');
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            var cartError = new Error(json.description || json.message || 'This item could not be added.');
            cartError.isCartError = true;
            throw cartError;
          }
          return json;
        });
      })
      .then(function () {
        if (status) status.textContent = button.getAttribute('data-added-label') || 'Added to bag';
        refreshCart();
        openCart();
      })
      .catch(function (error) {
        if (error && error.isCartError) {
          if (status) {
            status.textContent = error.message;
            status.classList.add('is-error');
          }
          return;
        }
        // Network or unexpected response: let the browser do a normal add-to-cart POST.
        form.submit();
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label) label.textContent = originalLabel;
      });
  }

  // Capture phase + stopPropagation so no other script (theme or app) also submits this form.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-lt-article-atc]')) return;
      event.preventDefault();
      event.stopPropagation();
      addToBag(form);
    },
    true
  );
})();
